import React, { useMemo, useState } from 'react'

import { TableCustom } from "../../../../../components/common"
import PlanPagoDefinicionCaducidadCuotaModal from '../../../../../components/controls/PlanPagoDefinicionCaducidadCuotaModal'
import { buildCellAVMR } from "../../../utils"
import { OPERATION_MODE } from '@laramie/ui';

const DefinicionCaducidad = ({ data, setData, params, setPendingChange }) => {
    const [edittingCaducidad, setEdittingCaducidad] = useState()
    const [mode, setMode] = useState()

    const filteredData = useMemo(() => !data ? [] : data.filter(x => x.state !== 'r'), [data])

    const onAdd = () => {
        setEdittingCaducidad({
            id: -Date.now(),
            idPlanPagoDefinicion: parseInt(params.id),
            cuotaDesde: 0,
            cuotaHasta: 0,
            caducidadAnticipoImpago: false,
            caducidadCantidadCuotasConsecutivas: 0,
            caducidadCantidadCuotasNoConsecutivas: 0,
            caducidadCantidadDiasVencimiento: 0,
            caducidadCantidadDeclaracionesJuradas: 0,
            state: 'a',
        })
        setMode('add')
    }

    const onView = (caducidad) => {
        setEdittingCaducidad(caducidad)
        setMode('view')
    }

    const onModify = (caducidad) => {
        setEdittingCaducidad(caducidad)
        setMode('modify')
    }

    const onRemove = (caducidad) => {
        setData(data.map(x => x.id === caducidad.id ? {...x, state: 'r'} : x))
        setPendingChange(true)
    }

    const onConfirm = (row) => {
        if (mode === 'add') {
            setData([...data, row])
        }

        else if (mode === 'modify') {
            setData(data.map(x => x.id === row.id ? {...row, state: row.state === 'a' ? 'a' : 'm',} : x))
        }

        setMode(null)

        setPendingChange(true)
    }

    const onDismiss = () => {
        setEdittingCaducidad(null)
        setMode(null)
    }

    return (
        <div className="col-12">

            <div className="col-12 p-top-15">
                <label className="form-label">Caducidad</label>
                <TableCustom
                    showFilterGlobal={false}
                    floatingDownloadCSVButton={true}
                    className='TableCustomBase'
                    columns={[
                        { Header: 'Cuota desde', accessor: 'cuotaDesde', width: '13%' },
                        { Header: 'Cuota hasta', accessor: 'cuotaHasta', width: '13%' },
                        { Header: 'Anticipo impago', accessor: 'caducidadAnticipoImpago', width: '13%', Cell: ({ value }) => value ? 'Sí' : 'No' },
                        { Header: 'Cuotas impagas', accessor: 'caducidadCantidadCuotasNoConsecutivas', width: '13%' },
                        { Header: 'Cuotas consec.', accessor: 'caducidadCantidadCuotasConsecutivas', width: '13%' },
                        { Header: 'Días de venc.', accessor: 'caducidadCantidadDiasVencimiento', width: '13%' },
                        // { Header: 'DDJJ no present.', accessor: 'caducidadCantidadDeclaracionesJuradas', width: '12%' },
                        buildCellAVMR({ onAdd, onView, onModify, onRemove, readOnly: params.mode === OPERATION_MODE.VIEW }),
                    ]}
                    data={filteredData}
                />
            </div>

            {!!mode && (
                <PlanPagoDefinicionCaducidadCuotaModal
                    data={{ entity: edittingCaducidad }}
                    disabled={mode === 'view'}
                    onConfirm={onConfirm}
                    onDismiss={onDismiss}
                />
            )}
        </div>
    )
}

export default DefinicionCaducidad
